import type { TermsType } from '../../types/terms';

export interface LocalTerms {
  content: string;
  version: string;
  effectiveDate: string;
  title: string;
}

const SERVICE_TERMS_CONTENT = `## 제1장 총칙

### 제1조 (목적)

이 약관은 주식회사 Plum Blossom(이하 "회사")가 운영하는 Silver Connect 서비스(이하 "서비스")의 이용 조건 및 절차, 회사와 이용자의 권리·의무 및 책임 사항, 기타 필요한 사항을 규정함을 목적으로 합니다.

### 제2조 (정의)

이 약관에서 사용하는 용어의 정의는 다음과 같습니다.

1. "**서비스**"란 회사가 제공하는 시니어 대상 **이성 간** 커플매칭(데이팅) 서비스로, 웹사이트(모바일 웹 포함)를 통해 이용할 수 있는 매칭, 채팅 등 일체의 서비스를 말합니다.
2. "**이용자**"란 이 약관에 따라 회사가 제공하는 서비스를 이용하는 자를 말합니다.
3. "**회원**"이란 회사에 회원가입을 한 후 본인인증 및 프로필 심사를 거쳐 정회원(APPROVED) 자격을 부여받은 이용자를 말합니다.
4. "**하트(Heart)**"란 서비스 내에서 사용되는 유료 디지털 콘텐츠(가상 재화)로, 카드 오픈·연장 등 특정 기능 이용 시 소비되는 재화를 말합니다.
5. "**큐피드 카드(Cupid Card)**"란 매칭 알고리즘에 의해 이용자에게 발급되는 매칭 후보 카드로, 상대방의 프로필 정보가 포함된 디지털 카드를 말합니다.
6. "**오픈(Open)**"이란 잠금 상태의 큐피드 카드를 하트를 사용하여 열어 상대방의 상세 프로필을 확인하고 채팅을 시작할 수 있게 하는 행위를 말합니다.
7. "**연장(Extend)**"이란 큐피드 카드의 유효기간을 하트를 사용하여 연장하는 행위를 말합니다.
8. "**서비스 운영정책**"이란 이 약관에서 위임한 서비스 운영에 관한 세부 사항을 정한 별도의 규정을 말합니다.

### 제3조 (약관의 효력 및 변경)

1. 이 약관은 서비스 화면에 게시하거나 기타 방법으로 이용자에게 공지함으로써 효력이 발생합니다.
2. 회사는 합리적인 사유가 발생하는 경우 관련 법령에 위반되지 않는 범위 내에서 이 약관을 변경할 수 있습니다.
3. 회사가 약관을 변경하는 경우, 변경 내용과 적용일자를 명시하여 서비스 화면에 적용일자 **30일 전**부터 공지합니다. 다만, 이용자에게 불리한 변경의 경우 **전자우편(이메일)** 등으로 개별 통지합니다.
4. 이용자가 변경된 약관에 동의하지 않는 경우, 서비스 이용을 중단하고 탈퇴할 수 있습니다. 이용자에게 불리한 약관 변경의 경우, 회사는 개별 통지 시 "**약관 변경에 동의하지 않으시면 적용일 전까지 거부 의사를 표시하거나 서비스 이용계약을 해지하실 수 있으며, 기간 내 별도의 거부 의사를 표시하지 않으시면 변경된 약관에 동의한 것으로 간주합니다**"라는 내용을 명확히 고지합니다. 해당 고지를 하지 않은 경우 동의 간주의 효력이 발생하지 않습니다.

### 제4조 (약관 외 준칙)

1. 이 약관에서 정하지 않은 사항은 개인정보 처리방침, 서비스 운영정책 및 관계 법령(전자상거래법, 정보통신망법, 개인정보보호법, 결혼중개업법 등)에 따릅니다.
2. 이 약관에서 "서비스 운영정책에 따른다"고 위임한 사항에 대하여, 회사는 운영정책을 서비스 화면에 게시합니다. 운영정책 변경 시 변경 내용을 서비스 화면에 **7일 전** 공지합니다. 다만, **이용자에게 불리한 운영정책 변경**의 경우 **14일 전**에 공지하며, 변경 내용을 이용자에게 전자우편으로 개별 통지합니다.

---

## 제2장 서비스 이용계약

### 제5조 (이용 자격)

1. 서비스는 **만 50세 이상 70세 이하**의 대한민국 국적 성인을 대상으로 합니다.
2. 서비스 이용을 위해서는 다음 요건을 모두 충족해야 합니다.
   - 가. 회원가입 완료 (카카오 OAuth 또는 이메일 가입)
   - 나. 프로필 작성 완료 (사진, 직업, 거주지, 관심사, 자기소개 등)
   - 다. 본인인증 완료 (토스인증을 통한 실명·생년월일·성별 확인)
   - 라. 프로필 심사 통과 (APPROVED 상태)
3. 다음 각 호에 해당하는 자는 서비스 이용이 제한됩니다.
   - 가. 대상 연령(만 50세~70세)에 해당하지 않는 자
   - 나. 본인인증을 완료하지 않은 자
   - 다. 이전에 약관 위반으로 서비스 이용이 제한(차단)된 자
   - 라. 허위 정보로 가입을 시도하는 자
   - 마. 기혼자(법률상 혼인 상태인 자)

### 제6조 (회원가입)

1. 이용자는 회사가 정한 양식에 따라 회원 정보를 기입한 후, 이 약관에 동의한다는 의사 표시를 함으로써 회원가입을 신청합니다.
2. 회원가입 방법은 다음과 같습니다.
   - 가. 카카오 OAuth를 통한 간편 가입
   - 나. 이메일 및 비밀번호를 이용한 직접 가입
3. 회사는 다음 각 호에 해당하는 경우 회원가입을 거절하거나 사후에 이용계약을 해지할 수 있습니다.
   - 가. 타인의 명의를 도용한 경우
   - 나. 허위 정보를 기재한 경우
   - 다. 회사가 정한 이용 자격 요건을 충족하지 못한 경우
   - 라. 기타 관계 법령에 위반되거나 회사의 서비스 운영에 중대한 지장을 초래하는 경우

### 제7조 (본인인증 및 프로필 심사)

1. 이용자는 프로필 작성 완료 후, 심사 요청 전에 **토스인증**을 통한 본인인증을 완료해야 합니다.
2. 본인인증을 통해 확인되는 정보(실명, 생년월일, 성별)는 프로필에 자동 반영되며, 이용자가 임의로 변경할 수 없습니다. 변경이 필요한 경우 고객센터를 통해 별도 요청해야 합니다.
3. 본 서비스는 결혼중개업법의 취지에 따라 이용자의 기본 신원(실명, 나이, 성별)을 본인인증을 통해 확인합니다. 다만, 직업·자기소개·관심사 등 이용자가 자유롭게 입력하는 항목의 진위 여부는 회사가 보증하지 않으며, 이용자 본인이 정확성에 대한 책임을 부담합니다.
4. 이용자가 프로필 작성 및 본인인증을 완료한 후 심사를 요청하면, 회사의 운영진이 프로필 사진의 적절성, 정보의 완성도, 서비스 정책 위반 여부 등을 검토합니다.
5. 심사 결과는 **승인(APPROVED)** 또는 **거절(REJECTED)** 로 통보되며, 거절 시 사유가 함께 안내됩니다. 거절된 이용자는 프로필을 수정한 후 **최대 3회까지** 재심사를 요청할 수 있습니다.

---

## 제3장 서비스 이용

### 제8조 (서비스 내용)

1. 회사가 제공하는 서비스의 내용은 다음과 같습니다.
   - 가. **큐피드 카드 매칭**: 정기 배치로 매칭 후보 카드를 발급
   - 나. **카드 오픈**: 하트를 사용하여 큐피드 카드를 열어 상세 프로필 확인
   - 다. **카드 연장**: 하트를 사용하여 카드 유효기간 연장
   - 라. **채팅**: 오픈된 카드의 상대방과 메시지 교환
   - 마. **프로필 관리**: 프로필 작성, 수정 및 관리
   - 바. **하트 충전**: 유료 결제를 통한 하트 구매
2. 본 서비스는 **편도 오픈** 방식을 채택합니다. 이용자 A가 이용자 B의 카드를 오픈(하트 사용)하면, B는 별도의 하트 사용 없이 A와 채팅할 수 있습니다. 이용자는 다른 회원이 본인의 카드를 오픈하여 대화를 시작할 수 있음을 이해하고 동의합니다.
3. 원치 않는 연락을 받은 경우 즉시 **차단** 및 **신고** 기능을 이용할 수 있습니다.
4. 큐피드 카드의 발급 주기, 수량, 유효기간, 상태 등 세부 사항은 **서비스 운영정책**에 따릅니다.
5. 회사는 서비스의 내용을 변경할 수 있으며, 중요한 변경 사항은 사전에 공지합니다.

### 제9조 (매칭)

1. 매칭은 이용자의 프로필 정보(거주지, 나이 선호, 관심사, 활동성 등)를 기반으로 **이성 간**에 **자동화된 알고리즘**에 의해 이루어집니다.
2. 매칭 후보의 수, 선호 조건 부합 여부, 서비스 내 회원 풀 등에 따라 발급 카드 수는 달라질 수 있으며, 0장이 발급될 수도 있습니다.
3. 매칭 후보가 부족한 경우 선호 조건이 일부 완화되어 매칭될 수 있습니다. 매칭 조건 완화의 세부 기준은 **서비스 운영정책**에 따릅니다.
4. 자동화된 의사결정에 관한 이용자의 권리(설명 요구권, 거부권)는 **개인정보 처리방침**에서 정합니다.

### 제10조 (채팅)

1. 채팅은 카드가 오픈된 상대방과 카드 유효기간 동안 이용할 수 있으며, 카드가 최종 소멸되면 채팅도 종료됩니다.
2. 채팅 내용은 신고 처리·분쟁 대응·수사 협조 등을 위해 **90일간** 보관되며, 보관 기간 경과 후 파기됩니다. 다만, 신고가 접수되어 처리 중인 건의 채팅 내용은 처리 완료 시까지 보관됩니다.
3. 채팅 내용은 신고 처리 시 회사가 열람할 수 있으며, 이용자는 서비스 가입 시 이에 동의합니다.

---

## 제4장 유료 서비스

### 제11조 (하트의 성격)

1. 하트는 서비스 내에서만 사용할 수 있는 **디지털 콘텐츠(가상 재화)**이며, 현금 또는 다른 재화로 환산·교환되지 않습니다.
2. 구매한 하트는 **유효기간이 없으며(무기한)**, 서비스 이용 중 언제든지 사용할 수 있습니다.
3. 하트는 양도, 대여, 매매할 수 없으며, 이를 시도하는 행위는 금지됩니다.

### 제12조 (하트 구매 및 사용)

1. 이용자는 서비스 내 결제 기능을 통해 회사가 정한 가격에 따라 하트를 구매할 수 있습니다. 하트 가격 및 구성은 서비스 내 결제 화면에서 확인할 수 있습니다.
2. 회사는 일정 조건 충족 시 리워드 하트를 무료로 지급할 수 있으며, 리워드 조건 및 지급량은 **서비스 운영정책**에 따릅니다.
3. 하트는 카드 오픈, 카드 연장 등 서비스 기능 이용 시 소비됩니다. 기능별 소비 하트 수는 **서비스 운영정책**에 따릅니다.
4. 하트 차감은 해당 기능 수행 시점에 **즉시** 발생하며, 사용된 하트는 원칙적으로 복구되지 않습니다.
5. 리워드 하트와 구매 하트는 동일하게 사용됩니다. 단, 환불 시 리워드 하트는 환불 대상에서 제외됩니다.

### 제13조 (결제)

1. 하트 구매 시 결제는 회사가 제공하는 간편결제 수단(토스페이, 네이버페이, 카카오페이 등)을 통해 이루어지며, 결제 금액에는 부가가치세가 포함되어 있습니다.
2. 결제 오류 또는 중복 결제가 확인된 경우, 고객센터로 연락하시면 **3영업일 이내**에 환불 또는 하트 지급으로 조치합니다.
3. 모든 결제 기록은 관련 법령(전자상거래법)에 따라 **5년간** 보관됩니다.

### 제14조 (청약철회 및 환불)

1. **미사용 하트 환불**: 구매일로부터 **7일 이내**, 하트를 전혀 사용하지 않은 경우 전액 환불이 가능합니다. 구매일로부터 7일이 경과한 경우에도 미사용 하트에 대해서는 제2항에 따라 환불을 청구할 수 있습니다.
2. **일부 사용 후 환불**: 구매한 하트 중 일부를 사용한 경우, 미사용 하트에 대해 구매 시 하트당 단가를 기준으로 환불하며, 환불 금액의 10% 이내 수수료가 부과될 수 있습니다.
3. **환불 제한**: 이미 사용된 하트, 리워드로 획득한 하트, 구매일로부터 7일 경과 후 모두 사용한 하트는 환불이 제한됩니다.
4. **사용된 하트의 청약철회 제한**: 하트를 사용하여 카드를 오픈하거나 연장하는 행위는 디지털 콘텐츠의 이용 개시에 해당하며, 전자상거래법 제17조 제2항 제5호에 따라 **청약철회가 제한**됩니다. 회사는 하트 사용 시 이를 사전 고지하며, 이용자의 확인을 받습니다. 다만, 미사용분에 대해서는 가분적 디지털 콘텐츠로서 청약철회가 가능합니다.
   > **시용(試用) 안내:** 회사는 신규 가입 시 리워드 하트를 무료로 지급하여 이용자가 하트 사용 경험을 사전에 체험할 수 있도록 합니다. 이는 전자상거래법 제17조 제6항에 따른 시용 제공에 해당합니다.
5. **환불 절차**: 환불 요청은 고객센터를 통해 접수하며, 접수일로부터 **3영업일 이내**에 원래 결제 수단으로 환불합니다.
6. **서비스 종료 시 하트 처리**: 회사가 서비스를 종료하는 경우, 종료일로부터 **30일 이상 전에** 공지하며, 이용자가 보유한 미사용 유료 하트는 구매 시 단가를 기준으로 환불합니다. 환불 청구는 서비스 종료 공지일로부터 **90일 이내**에 하여야 합니다.

---

## 제5장 이용자의 의무 및 제재

### 제15조 (이용자의 의무)

1. 이용자는 가입 시 정확하고 진실된 정보를 제공하고, 변경 시 지체 없이 갱신해야 합니다.
2. 이용자는 자신의 계정 정보를 안전하게 관리해야 하며, 타인에게 양도·대여할 수 없습니다.
3. 이용자는 서비스 이용 시 다음 각 호의 행위를 하여서는 안 됩니다.
   - 가. 허위 정보를 등록하거나 타인의 정보를 도용하는 행위, 기혼 사실을 숨기고 서비스를 이용하는 행위
   - 나. 상대방의 거부 의사에 반하여 반복적으로 연락하거나, 위협·협박하거나, 상대방이 불쾌할 수 있는 성적인 메시지나 사진을 보내는 행위
   - 다. 금전을 요구하거나 개인 금융정보를 요구하는 행위 (로맨스 스캠 포함)
   - 라. 타인의 개인정보를 무단으로 수집·저장·유포하거나, 서비스 내 정보(채팅 내용, 프로필 등)를 외부에 무단 공개하는 행위
   - 마. 기타 서비스 운영정책에서 정하는 금지행위
4. 이용자는 관계 법령, 이 약관 및 서비스 운영정책을 준수해야 합니다.

### 제16조 (서비스 이용 제한)

1. 회사는 이용자가 제15조를 위반한 경우, 경고, 일시정지, 영구차단 등의 조치를 취할 수 있습니다. 제재 단계 및 적용 기준의 세부 사항은 **서비스 운영정책**에 따릅니다.
2. 긴급한 경우(스토킹, 성적 메시지, 사기 등 중대한 위반) 사전 경고 없이 **즉시** 서비스 이용을 제한할 수 있습니다.
3. 서비스 이용이 제한된 경우, 제한 사유 및 기간을 이용자에게 통지합니다.

### 제17조 (신고 및 이의제기)

1. 이용자는 다른 이용자의 부적절한 행위를 신고할 수 있으며, 회사는 신고 접수 시 **24시간 이내**에 1차 검토를 진행합니다.
2. 서비스 이용 제한에 대해 이의가 있는 이용자는 제한 통지를 받은 날로부터 **14일 이내**에 고객센터를 통해 이의를 제기할 수 있으며, 회사는 **7영업일 이내**에 조사 결과를 통보합니다.
3. 이의가 정당한 것으로 인정되는 경우, 회사는 즉시 이용 제한을 해제하고 적절한 보상을 제공합니다.
4. 허위 신고를 반복하는 경우, 신고 기능 또는 서비스 이용이 제한될 수 있습니다.

---

## 제6장 계약 해지 및 기타

### 제18조 (탈퇴)

1. 이용자는 언제든지 서비스 내 탈퇴 기능 또는 고객센터를 통해 이용계약의 해지(탈퇴)를 요청할 수 있습니다.
2. 탈퇴 시 다음과 같이 처리됩니다.
   - 가. 보유 중인 미사용 하트에 대한 환불은 제14조에 따릅니다.
   - 나. 진행 중인 큐피드 카드 및 채팅은 즉시 종료됩니다.
   - 다. 개인정보는 관련 법령에 따른 보관 의무 항목을 제외하고 **즉시 파기**합니다.
   - 라. 법령에 따라 분리 보관되는 항목 및 기간은 다음과 같습니다.

| 보관 항목 | 보관 기간 | 근거 법령 |
|----------|:---------:|----------|
| 계약 또는 청약철회 등에 관한 기록 | 5년 | 전자상거래법 제6조 |
| 대금결제 및 재화 등의 공급에 관한 기록 | 5년 | 전자상거래법 제6조 |
| 소비자 불만 또는 분쟁 처리에 관한 기록 | 3년 | 전자상거래법 제6조 |
| 접속 기록(로그인 일시, IP 주소 등) | 3개월 | 통신비밀보호법 제15조의2 |
| CI/DI (재가입 방지 목적) | 1년 | 개인정보보호법 제15조 |

3. 탈퇴 후 동일 본인인증 정보로 재가입하는 경우, 이전 이용 내역은 복구되지 않습니다.

### 제19조 (휴면 계정)

1. 최근 30일 이내 로그인 기록이 없는 이용자는 매칭 풀에서 **자동으로 제외**됩니다. 재로그인 시 즉시 매칭 풀에 복귀됩니다.
2. 1년 이상 로그인하지 않은 계정은 관련 법령에 따라 **휴면 계정으로 전환**될 수 있으며, 사전에 전자우편으로 안내합니다.

### 제20조 (회사의 의무와 면책)

1. 회사는 관련 법령과 이 약관이 정하는 바에 따라 지속적이고 안정적인 서비스를 제공하기 위해 최선을 다하며, 이용자의 개인정보를 안전하게 관리하기 위한 기술적·관리적 보호조치를 시행합니다.
2. 회사는 이용자에게 최적의 매칭 경험을 제공하기 위해 노력합니다. 다만, 매칭은 자동화된 알고리즘에 의해 이루어지며, 이용자 풀의 구성·활동 상황 등에 따라 매칭 결과가 달라질 수 있습니다.
3. 회사는 이용자가 제공한 프로필 정보의 진위 여부를 완전히 보증하지 않습니다. 본인인증을 통해 실명·생년월일·성별은 확인되나, 이용자 자유 입력 항목에 대해서는 이용자 본인에게 책임이 있습니다.
4. 이용자 간의 분쟁에 대해 회사는 중개 역할을 할 수 있으나 분쟁의 당사자는 아닙니다. 다만, 서비스 내에서 발생한 분쟁에 대해 신고 접수, 제재 조치 등 운영적 대응을 합니다.
5. 천재지변, 전쟁, 해킹 등 회사의 합리적 통제 범위를 벗어난 사유로 서비스 제공이 중단된 경우, 회사는 이로 인한 손해에 대해 책임을 지지 않습니다. 다만, 개인정보 유출의 경우 관련 법령에 따라 **72시간 이내**에 이용자에게 통지합니다.
6. 회사는 이용자의 개인정보를 **개인정보 처리방침**에 따라 수집·이용·관리하며, 개인정보 처리방침은 서비스 화면에 별도로 게시합니다.
7. 법원의 영장 또는 수사기관의 적법한 요청이 있는 경우, 관련 법령에 따라 이용자의 서비스 이용 기록을 제공할 수 있습니다.
8. 회사가 이용자에게 통지하는 경우, 서비스 내 알림 또는 전자우편 등의 방법으로 합니다. 불특정 다수에 대한 통지는 서비스 화면에 7일 이상 게시함으로써 개별 통지에 갈음할 수 있습니다.
9. 이용자는 서비스 이용 계약상의 지위 또는 권리·의무를 타인에게 양도, 증여, 담보 제공 등 처분할 수 없습니다.

### 제21조 (이용자 안전)

1. 서비스 이용과 관련하여 안전상의 위협이나 불쾌하거나 부당한 행위를 경험한 이용자에 대해 회사는 다음과 같은 지원을 제공합니다.
   - 가. 가해자에 대한 즉시 이용 제한 조치
   - 나. 관련 상담기관 안내 (여성긴급전화 1366, 경찰 112, 금융감독원 1332, 성폭력상담소 1899-3075)
   - 다. 수사기관 요청 시 관련 기록 제공
2. 피해 회원의 개인정보가 가해자에게 노출된 경우, 추가 피해 방지를 위한 조치를 취하며, 사기 피해의 경우 2차 피해 예방 안내(비밀번호 변경, 계좌 지급정지, 명의도용 확인 등)를 제공합니다.
3. 이용자 간 오프라인 만남은 이용자 본인의 판단과 책임 하에 이루어집니다. 회사는 이용자의 안전을 위한 안전 수칙을 서비스 화면에 게시합니다.
4. 사기·해악 행위가 확인된 이용자에 대해 회사는 **사전 경고 없이 즉시 영구 차단**하며, 재가입을 영구 차단합니다.

---

## 제7장 분쟁 해결

### 제22조 (분쟁 해결 및 관할)

1. 서비스 이용과 관련하여 회사와 이용자 사이에 분쟁이 발생한 경우, 양 당사자는 원만한 해결을 위해 성실히 협의합니다.
2. 협의로 해결되지 않는 경우, 이용자는 한국소비자원 소비자분쟁조정위원회, 한국인터넷진흥원(KISA) 개인정보분쟁조정위원회, 전자거래분쟁조정위원회에 분쟁 조정을 신청할 수 있습니다.
3. 이 약관과 관련된 소송은 **민사소송법**에 따른 관할 법원에 제기합니다.

### 제23조 (준거법)

이 약관의 해석 및 적용에는 **대한민국 법령**을 준거법으로 합니다.

---

## 부칙

이 약관은 2026년 ○○월 ○○일부터 시행합니다.
`;

const PRIVACY_CONSENT_CONTENT = `주식회사 Plum Blossom(이하 "회사")는 Silver Connect 서비스(이하 "서비스") 제공을 위해 개인정보보호법 제15조 및 제17조에 따라 아래와 같이 개인정보를 수집·이용·제공하고자 합니다. 내용을 자세히 읽으신 후 동의 여부를 결정하여 주시기 바랍니다.

---

## 1절. 회원가입 정보 수집

| # | 수집 항목 | 수집 방식 | 필수/선택 |
|---|----------|----------|:--------:|
| 1 | 이메일 주소 | 이용자 직접 입력 | 필수 |
| 2 | 비밀번호 (해시 저장) | 이용자 직접 입력 | 필수 (이메일 가입 시) |
| 3 | 카카오 계정 식별자 (OAuth ID) | 카카오 OAuth 연동 | 필수 (카카오 가입 시) |

**수집·이용 목적:** 회원 식별, 로그인 인증, 서비스 이용 계약 체결 및 이행, 공지사항 및 알림 발송

**보유 및 이용 기간:** 회원 탈퇴 시까지. 단, 관계 법령에 따라 보존이 필요한 경우 해당 기간까지 보관 (하단 보관 기간 표 참조)

---

## 2절. 본인확인 정보 수집

| # | 수집 항목 | 수집 방식 | 수집 목적 | 필수/선택 |
|---|----------|----------|----------|:--------:|
| 1 | 실명 (이름) | 토스인증 자동 수집 | 실명 확인, 프로필 잠금 필드 | 필수 |
| 2 | 생년월일 | 토스인증 자동 수집 | 나이 확인 (50~70세), 매칭 | 필수 |
| 3 | 성별 | 토스인증 자동 수집 | 이성 매칭, 프로필 잠금 필드 | 필수 |
| 4 | 국적 | 토스인증 자동 수집 | 이용 자격 확인 | 필수 |
| 5 | CI (연계정보) | 토스인증 자동 수집 | 중복 계정 방지 | 필수 |
| 6 | DI (중복가입확인정보) | 토스인증 자동 수집 | 동일 서비스 중복 가입 방지 | 필수 |

**인증 서비스 제공자:** 주식회사 비바리퍼블리카 (토스) — 토스인증(바로사인) 방식

**프로필 반영:** 인증된 실명, 생년월일, 성별은 프로필에 자동 반영되며, 이용자가 임의로 변경할 수 없습니다(잠금 필드). 변경이 필요한 경우 고객센터를 통해 별도 요청해야 합니다.

**보유 및 이용 기간:**

| 정보 유형 | 보유 기간 | 비고 |
|----------|:---------:|------|
| 실명, 생년월일, 성별 (프로필용) | 회원 탈퇴 시 즉시 파기 | — |
| CI/DI | 탈퇴 후 **1년** 보관 후 파기 | 재가입 방지 목적, 암호화 저장 |
| 인증 감사 로그 | 탈퇴 후 **1년** 보관 후 파기 | AES-256 암호화 저장 |

---

## 3절. 프로필 정보 수집 및 매칭

| # | 수집 항목 | 수집 방식 | 필수/선택 |
|---|----------|----------|:--------:|
| 1 | 프로필 사진 (최소 3장, 최대 10장) | 이용자 업로드 | 필수 |
| 2 | 직업 | 이용자 직접 입력 | 필수 |
| 3 | 거주지 (시도/시군구) | 이용자 선택 | 필수 |
| 4 | 한 줄 소개 | 이용자 직접 입력 | 필수 |
| 5 | 자기소개 | 이용자 직접 입력 | 필수 |
| 6 | 관심사 (복수 선택) | 이용자 선택 | 필수 |
| 7 | 선호 나이 | 이용자 선택 | 필수 |
| 8 | 선호 지역 | 이용자 선택 | 선택 |

**수집·이용 목적:** 매칭 알고리즘 적용, 큐피드 카드를 통한 프로필 타 회원 노출, 프로필 심사

**보유 및 이용 기간:** 회원 탈퇴 시 즉시 파기 (프로필 사진 파일 포함)

> **자동 매칭 안내**
> 본 서비스는 회원님의 거주지·관심사 등을 바탕으로 자동으로 인연을 추천해드립니다.
> 추천 방식에 대한 설명이나 중단을 원하시면 고객센터로 요청하실 수 있습니다.

---

## 4절. 제3자 제공

회사는 서비스 제공을 위해 아래와 같이 이용자의 개인정보를 제3자에게 제공합니다.

| 제공 대상 | 제공 항목 | 제공 목적 | 보유 기간 |
|----------|----------|----------|:---------:|
| **매칭된 타 회원** | 프로필 정보 (사진, 지역, 연령대, 관심사, 직업, 소개) | 매칭 서비스 제공 | 카드 유효기간까지 |
| PG사 (간편결제) | 결제 요청 정보 | 하트 충전 결제 처리 | PG사 정책에 따름 |
| 카카오 | OAuth 인증 정보 | 간편 로그인 | 카카오 정책에 따름 |
| 토스 (비바리퍼블리카) | 인증 요청 정보 | 본인인증 수행 | 토스 정책에 따름 |

**매칭 상대방에 대한 프로필 제공 안내:**
- 카드 미오픈(LOCKED) 시: 블러 처리된 사진, 지역(시도), 연령대, 관심사만 제한적 노출
- 카드 오픈(OPENED) 시: 원본 사진, 이름, 나이, 성별, 거주지, 직업, 소개 전체 노출
- 카드 소멸(DEAD) 시: 정보 제공 종료

> 본 서비스는 **편도 오픈** 방식입니다. 상대 회원이 하트를 사용하여 내 카드를 오픈하면, 나의 전체 프로필이 상대방에게 공개됩니다. 이용자는 본 동의서에 동의함으로써 이러한 프로필 공개 방식에 동의합니다. 원치 않는 연락은 차단·신고 기능으로 대응할 수 있습니다.

---

## 5절. 자동 수집 정보

| # | 수집 항목 | 수집 목적 | 보유 기간 |
|---|----------|----------|:---------:|
| 1 | 로그인 시각 | 활동성 점수, 휴면 판별 | 탈퇴 시 파기 |
| 2 | 채팅 메시지 | 서비스 제공, 신고 처리 | 카드 만료 후 90일 |
| 3 | 카드 오픈·연장 이력 | 이용 기록, 하트 차감 근거 | 탈퇴 시 파기 |
| 4 | 하트 거래 내역 | 정산, 이의 처리 | 5년 (전자상거래법) |
| 5 | 신고·차단 내역 | 안전 관리, 제재 근거 | 3년 (전자상거래법) |
| 6 | 접속 기록 (IP, 기기 정보) | 보안, 법적 보관 의무 | 3개월 (통신비밀보호법) |
| 7 | 매칭 이력 | 중복 매칭 방지(4주 쿨타임), 매칭 다양성 보장 | 운영용 4주 파기 + 감사용 1년(익명화) 보관 후 파기 |
| 8 | 심사 이력 (결과, 거절 사유) | 재심사 처리, 이의 대응 | 탈퇴 시 파기 |
| 9 | 프로필 수정 이력 | 심사 필드 변경 관리 | 탈퇴 시 파기 |
| 10 | 본인인증 시도 이력 (성공/실패) | 어뷰징 방지, 감사 | 탈퇴 후 1년 보관 후 파기 |

---

## 6절. 결제 정보

| # | 수집 항목 | 수집 목적 | 보유 기간 |
|---|----------|----------|:---------:|
| 1 | 결제 금액·일시 | 거래 기록, 환불 처리 | 5년 (전자상거래법) |
| 2 | 구매 상품 정보 (하트 팩) | 거래 기록 | 5년 (전자상거래법) |

> 신용카드 번호 등 민감 결제 정보는 PG사가 직접 처리하며, 회사 서버에 저장하지 않습니다.

---

## 7절. 개인정보 처리 위탁

| 수탁업체 | 위탁 업무 |
|---------|----------|
| 클라우드 서비스 제공업체 (AWS 등) | 데이터 저장·관리, 사진 파일 호스팅 |

---

## 법령에 따른 보관 기간 종합

| 보관 항목 | 보관 기간 | 근거 법령 |
|----------|:---------:|----------|
| 계약·청약철회 기록 | 5년 | 전자상거래법 제6조 |
| 대금결제·재화 공급 기록 | 5년 | 전자상거래법 제6조 |
| 소비자 불만·분쟁 처리 기록 | 3년 | 전자상거래법 제6조 |
| 접속 기록 (로그인, IP) | 3개월 | 통신비밀보호법 제15조의2 |
| CI/DI (재가입 방지) | 탈퇴 후 1년 | 개인정보보호법 제15조 |

---

## 정보주체의 권리

1. 이용자는 언제든지 자신의 개인정보에 대해 **열람, 정정·삭제, 처리정지**를 요구할 수 있습니다.
2. 개인정보 관련 요청은 고객센터 또는 개인정보 보호책임자에게 하실 수 있으며, **10일 이내**에 조치합니다.
3. 법령에 따라 보관 의무가 있는 정보는 해당 기간까지 보관됩니다.

---

## 동의 거부 권리 및 불이익

- 이용자는 위 개인정보 수집·이용·제3자 제공에 대한 동의를 거부할 권리가 있습니다.
- 다만, **필수 항목**에 대한 동의를 거부하시는 경우 서비스 회원가입 및 이용이 불가능합니다.
- **선택 항목**(선호 지역)에 대한 동의를 거부하시더라도 서비스 이용에는 제한이 없습니다. 다만, 매칭 정확도가 낮아질 수 있습니다.

---

**☐ 개인정보 수집·이용 및 제3자 제공에 동의합니다. (필수)**
`;

const MARKETING_CONSENT_CONTENT = `이벤트·프로모션 등 마케팅 정보를 이메일로 보내드립니다 (주 1회 이내).

| 항목 | 내용 |
|------|------|
| **발송 수단** | 전자우편 (이메일) |
| **이용하는 개인정보** | 이메일 주소 |
| **발송 내용** | 프로모션, 할인 이벤트, 신규 기능 안내, 서비스 활용 팁 |
| **발송 빈도** | 주 1회 이내 |

---

## 수신 거부

수신을 원하지 않으시면 **언제든** 아래 방법으로 거부하실 수 있습니다.

- 서비스 내 설정: 마이페이지 > 알림 설정 > 마케팅 수신 OFF
- 마케팅 이메일 하단의 [수신 거부] 링크 클릭
- 고객센터 연락

수신 거부 시에도 카드 발급, 심사 결과, 약관 변경 등 **서비스 필수 알림**은 정상적으로 발송됩니다.

---

## 동의 거부 권리

- 동의를 거부하더라도 **서비스 이용에는 아무런 제한이 없습니다.**
- 다만, 프로모션·할인 등 혜택 정보를 받아보실 수 없습니다.
- 마케팅 목적으로 이용하는 이메일 주소는 **동의 철회 시** 마케팅 용도 이용을 즉시 중단합니다.

---

**☐ 마케팅 정보 수신(이메일)에 동의합니다. (선택)**
`;

const PURCHASE_CONFIRM_CONTENT = `## 팝업 문구

> **하트 구매 안내**
>
> 하트는 디지털 콘텐츠로, 사용 후에는 환불이 제한됩니다.
> 미사용 하트는 환불 가능합니다.
>
> [상세 보기]
>
> ☐ 확인했습니다
>
> [₩○,○○○ 결제하기]

---

## [상세 보기] 링크 내용

> **환불 안내**
>
> - 구매 후 7일 이내, 미사용 시 전액 환불 가능
> - 일부 사용 후에도 미사용 하트는 환불 가능 (수수료 10% 이내)
> - 사용된 하트는 환불 불가 (전자상거래법 제17조)
> - 리워드(무료) 하트는 환불 대상 아님
> - 환불 요청: 고객센터 (3영업일 이내 처리)
>
> 자세한 사항은 서비스 이용약관 제14조를 참고하세요.

---

## 구현 참고사항

| 항목 | 내용 |
|------|------|
| 노출 시점 | 이용자의 **최초** 하트 구매 결제 화면 진입 시 |
| 노출 방식 | 모달 팝업 또는 결제 화면 내 인라인 표시 |
| 체크박스 | "확인했습니다" 체크 필수 (미체크 시 결제 버튼 비활성화) |
| 2회차 이후 | 체크박스 없이 안내 문구만 결제 화면에 표시 |
| 접근성 | 글자 크기 16px 이상, 명확한 대비 |

---

*본 문서는 전자상거래법 제17조 제2항 제5호(디지털 콘텐츠 청약철회 제한 사전 고지) 요건을 충족하기 위한 UI 문구입니다.*
`;

export const TERMS_DATA: Record<TermsType, LocalTerms> = {
  SERVICE_TERMS: {
    content: SERVICE_TERMS_CONTENT,
    version: '2.0.0',
    effectiveDate: '2026-01-01',
    title: '서비스 이용약관',
  },
  PRIVACY_CONSENT: {
    content: PRIVACY_CONSENT_CONTENT,
    version: '2.0.0',
    effectiveDate: '2026-01-01',
    title: '개인정보 수집·이용 및 제3자 제공 동의',
  },
  MARKETING_CONSENT: {
    content: MARKETING_CONSENT_CONTENT,
    version: '2.0.0',
    effectiveDate: '2026-01-01',
    title: '마케팅 정보 수신 동의',
  },
  PURCHASE_CONFIRM: {
    content: PURCHASE_CONFIRM_CONTENT,
    version: '1.0.0',
    effectiveDate: '2026-01-01',
    title: '하트 구매 청약철회 안내',
  },
};
